webpackJsonp(["nt-main.app"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
  // is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
  // is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
  // double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit');

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === (typeof console === 'undefined' ? 'undefined' : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch (e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch (e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js");

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0,
      i;

  for (i in namespace) {
    hash = (hash << 5) - hash + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy() {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Hash.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hashClear = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashClear.js"),
    hashDelete = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashDelete.js"),
    hashGet = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashGet.js"),
    hashHas = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashHas.js"),
    hashSet = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashSet.js");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_ListCache.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var listCacheClear = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getNative.js"),
    root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_MapCache.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapCacheClear = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheClear.js"),
    mapCacheDelete = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheDelete.js"),
    mapCacheGet = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheGet.js"),
    mapCacheHas = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheHas.js"),
    mapCacheSet = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheSet.js");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var eq = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsNative.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isFunction.js"),
    isMasked = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isMasked.js"),
    isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js"),
    toSource = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_toSource.js");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_coreJsData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getMapData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isKeyable = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isKeyable.js");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getNative.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsNative = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseIsNative.js"),
    getValue = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getValue.js");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getValue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashClear.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeCreate.js");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashDelete.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashGet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashHas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeCreate.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_hashSet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeCreate.js");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isKeyable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_isMasked.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreJsData = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_coreJsData.js");

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheClear.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Hash = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Hash.js"),
    ListCache = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_ListCache.js"),
    Map = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_Map.js");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getMapData.js");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getMapData.js");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getMapData.js");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_mapCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getMapData.js");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_nativeCreate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_getNative.js");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_objectToString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_toSource.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/eq.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isString.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_baseGetTag.js"),
    isArray = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/memoize.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MapCache = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/_MapCache.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/dynamic-load.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSETS = exports.MODULE_SELECTOR = exports.MODULE_NAME = undefined;
exports.default = load;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// Constants
/**
 * Cover Selector - Dynamic Load
 * Responsible for determining if the Cover Selector needs to load, and for actually loading the files.
 */

//
// Utilities
//
// Dependencies
var MODULE_NAME = exports.MODULE_NAME = _names.COVER_SELECTOR_MODULE;
var MODULE_SELECTOR = exports.MODULE_SELECTOR = '[data-cover-selector]';
var ASSETS = exports.ASSETS = [
// '../styles/core-datepicker.module.css',
'../scripts/cover-selector.module.js'];
// theme specific cover selector css is loaded via a partial

//
// Load
function load() {
  registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/dynamic-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dynamicLoader;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _index = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var _toast = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/pyrsmk-toast/toast.js");

var _toast2 = _interopRequireDefault(_toast);

var _isString = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/isString.js");

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'dynamic-loader'; /**
                                     * Registry Dynamic Loader
                                     * Common dynamic loading template.
                                     * @author Rhys Lloyd
                                     */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);
//
// Dependencies


var staticPath = undefined;
var staticPathElement = document.querySelector('meta[name="site.paths.static"]');
if (staticPathElement) {
	staticPath = staticPathElement.content;
}

//
// Constants
var STATIC_PATH = staticPath;
var MANIFEST_FILE = STATIC_PATH + 'manifest.json';
var MANIFEST_FILE_DATA = undefined;
//
// Load

/**
 * Loads a module based on the existence of a selector.
 * @param {String} module - name of module to load (for registration)
 * @param {String} selector - selector to test for with document.querySelector
 * @param {Array} loadArray - array of assets to load (pass to toast.js)
 */
function dynamicLoader(module, selector, loadArray) {
	if ((0, _index.exists)(module)) {
		log('Module "' + module + '" already loaded. Exiting.');
		return;
	}

	log('Looking for selector "' + selector + '"');
	var hasElements = !!document.querySelector(selector);

	if (!hasElements) {
		log('...no elements. Exiting.');
		(0, _index.register)(module, _index.STATE.NOT_REQUIRED);
		return;
	}

	readTextFile(MANIFEST_FILE, getManifestFileName, loadArray, module);
}

function getManifestFileName(text, loadArray, module) {
	var MANIFEST_FILE_DATA = JSON.parse(text);
	var resolvedLoadArray = loadArray.map(function (item) {
		if (!(0, _isString2.default)(item)) {
			return item;
		}
		var newItem = item.replace('../', STATIC_PATH);
		if (MANIFEST_FILE_DATA[newItem]) {
			return MANIFEST_FILE_DATA[newItem];
		}
		return newItem;
	});

	log('Loading ' + module + ' with assetArray', resolvedLoadArray);
	_toast2.default.apply(null, resolvedLoadArray);

	(0, _index.register)(module, _index.STATE.LOADING);
}

function readTextFile(file, callback, loadArray, module) {
	var rawFile = new XMLHttpRequest();
	rawFile.overrideMimeType("application/json");
	rawFile.open("GET", file, true);
	rawFile.onreadystatechange = function () {
		if (rawFile.readyState === 4 && rawFile.status == "200") {
			return callback(rawFile.responseText, loadArray, module);
		}
	};
	rawFile.send(null);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = exports.STATE = undefined;

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

Object.keys(_names).forEach(function (key) {
	if (key === "default" || key === "__esModule") return;
	Object.defineProperty(exports, key, {
		enumerable: true,
		get: function get() {
			return _names[key];
		}
	});
});
exports.register = register;
exports.exists = exists;
exports.isRegistered = isRegistered;
exports.getState = getState;
exports.setState = setState;
exports.validState = validState;
exports.dynamicLoader = dynamicLoader;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _state = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/state.js");

var _state2 = _interopRequireDefault(_state);

var _dynamicLoader = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/dynamic-loader.js");

var dl = _interopRequireWildcard(_dynamicLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'registry'; /**
                               * Extremely Basic Module Registry
                               * Designed to prevent asynchronously modules from being loaded and run more than once.
                               * @author Rhys Lloyd
                               */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

//
// Dependencies


//
// Constants
var REGISTRY = {};
var STATE = exports.STATE = _state2.default;

//
// Functions

/**
 * Registers a module.
 * @param module
 * @param state
 * @returns {*}
 */
function register(module, state) {
	if (exists(module)) {
		log('register(): Attempting to re-register an existing module: "' + module + '"', 'Existing:', REGISTRY[module]);
		return;
	}

	if (!state || !validState(state)) {
		state = STATE.INIT;
	}

	REGISTRY[module] = {
		state: state
	};

	log('register(): Registering module "' + module + '" with state "' + state.name + '"');
	return REGISTRY[module];
}

/**
 * Returns the object in the registry
 * @param module
 * @returns {*}
 */
function exists(module) {
	return !!REGISTRY[module];
}

/**
 * Checks if a module is marked as registered.
 * @param module
 * @returns {*|boolean}
 */
function isRegistered(module) {
	return exists(module) && getState(module) == STATE.REGISTERED;
}

/**
 * Get the state of a registered module.
 * @param module
 * @returns {*}
 */
function getState(module) {
	if (!exists(module)) {
		log('getState(): module "' + module + '" doesn\'t exist');
		return;
	}

	var state = REGISTRY[module].state;
	log('getState(): Getting state "' + state.name + '" for module "' + module + '"');
	return state;
}

/**
 * Get the state of a registered module.
 * @param module
 * @param state
 * @returns {*}
 */
function setState(module, state) {
	if (!exists(module)) {
		log('setState(): module "' + module + '" doesn\'t exist');
		return;
	}

	if (!validState(state)) {
		log('setState(): state "' + state + '" doesn\'t exist (attempt on module "' + module + '")');
	}

	log('setState(): Setting state "' + state.name + '" for module "' + module + '"');
	REGISTRY[module].state = state;
}

/**
 * Verifies that a state is valid
 * @param state
 * @returns {boolean}
 */
function validState(state) {
	return state instanceof _state2.default;
}

exports.default = register;
function dynamicLoader(module, selector, loadArray) {
	return dl.default(module, selector, loadArray);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Registry Module Names
 */

// Core
var CORE_MODULE = exports.CORE_MODULE = 'core';
var DATEPICKER_MODULE = exports.DATEPICKER_MODULE = 'datepicker';
var PS_QUOTE_FORM_MODULE = exports.PS_QUOTE_FORM_MODULE = 'ps-quote-form';
var LOCATOR_MODULE = exports.LOCATOR_MODULE = 'locator';
var COVER_SELECTOR_MODULE = exports.COVER_SELECTOR_MODULE = "cover-selector";

// Dev
var DEV_MODULE = exports.DEV_MODULE = 'dev';
var DEV_THEME_SWITCHER = exports.DEV_THEME_SWITCHER = DEV_MODULE + '-theme-switcher';

// Health Fund
var HF_APP_MODULE = exports.HF_APP_MODULE = 'hf-app';
var HF_PRODUCT_SELECTOR_MODULE = exports.HF_PRODUCT_SELECTOR_MODULE = 'hf-product-selector';
var HF_PRODUCT_DETAIL_CARD_MODULE = exports.HF_PRODUCT_DETAIL_CARD_MODULE = 'hf-product-detail-card';

// NT Health Fund
var NT_HF_APP_MODULE = exports.NT_HF_APP_MODULE = 'nt-cu-app';

// SeeU
var SEEU_APP_MODULE = exports.SEEU_APP_MODULE = 'seeu-app';
// export const SEEU_PRODUCT_COMPARE_MODULE = 'cu-product-compare';

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/state.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enumify = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/enumify/enumify.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Registry States
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * States for Registry
 * See docs: https://github.com/rauschma/enumify
 */
var State = function (_Enum) {
  _inherits(State, _Enum);

  function State() {
    _classCallCheck(this, State);

    return _possibleConstructorReturn(this, (State.__proto__ || Object.getPrototypeOf(State)).apply(this, arguments));
  }

  return State;
}(_enumify.Enum);

State.initEnum(['INIT', 'FAIL', 'LOADING', 'LOADED', 'REGISTERED', 'NOT_REQUIRED', 'CANCELLED']);

exports.default = State;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/browser-features.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIOS = exports.isWindowsTouch = exports.isWindowsDevice = exports.hasDatesButNoTouch = exports.inputtypesDates = exports.geolocation = exports.cssTransitions = exports.promises = exports.touchEvents = undefined;

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/inputtypes.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/geolocation.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/touchevents.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/es6/promises.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/css/transitions.js");

var _browsernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/index.js");

var _browsernizr2 = _interopRequireDefault(_browsernizr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Browser Features
 */

// Modernizr Tests
var touchEvents = exports.touchEvents = _browsernizr2.default.touchevents;

// Dependencies
var promises = exports.promises = _browsernizr2.default.promises;
var cssTransitions = exports.cssTransitions = _browsernizr2.default.cssTransitions;
var geolocation = exports.geolocation = _browsernizr2.default.geolocation;

var inputtypesDates = exports.inputtypesDates = _browsernizr2.default.inputtypes.date;
var hasDatesButNoTouch = exports.hasDatesButNoTouch = inputtypesDates && !touchEvents;

var isWindowsDevice = exports.isWindowsDevice = navigator && navigator.appVersion && navigator.appVersion.indexOf('Win') >= 0;
var isWindowsTouch = exports.isWindowsTouch = touchEvents && isWindowsDevice;

var isIOS = exports.isIOS = navigator && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browserFeatures = exports.templateLoader = exports.polyfillFlags = undefined;

var _browserFeatures = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/browser-features.js");

var bf = _interopRequireWildcard(_browserFeatures);

var _polyfillFlags = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/polyfill-flags.js");

var pf = _interopRequireWildcard(_polyfillFlags);

var _templateLoader = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/template-loader.js");

var tl = _interopRequireWildcard(_templateLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var polyfillFlags = exports.polyfillFlags = pf; /**
                                                 * Core Services
                                                 */

var templateLoader = exports.templateLoader = tl;
var browserFeatures = exports.browserFeatures = bf;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/polyfill-flags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.useDateFieldPolyFill = undefined;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _browserFeatures = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/browser-features.js");

var BrowserFeatures = _interopRequireWildcard(_browserFeatures);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'polyfill-flags'; /**
                                     * Polyfill Flags
                                     */

// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

// Dependencies


log('BrowserFeatures', BrowserFeatures);
//noinspection OverlyComplexBooleanExpressionJS
var useDateFieldPolyFill =
// Use the polyfill if...

// There's no native date input
exports.useDateFieldPolyFill = !BrowserFeatures.inputtypesDates ||

// Or there is a native date input, but it's not a touch device
BrowserFeatures.hasDatesButNoTouch ||

// Otherwise, don't use the polyfill.
false;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/template-loader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTemplate = undefined;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _memoize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/lodash/memoize.js");

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODULE_NAME = 'templace-loader'; /**
                                      * Template Loader
                                      * @author Rhys Lloyd
                                      */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

/**
 * Load a template from a selector.
 * @type {Function}
 * @param selector - Selector for template
 * @param context - Optional context for the selector
 * @returns {String} - The template
 */
var loadTemplate = exports.loadTemplate = (0, _memoize2.default)(function (selector, context) {
  log('loadTemplate() loading template', selector, 'with context', context);
  return $(selector, context).html();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js"),
    ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js"),
    classes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/classes.js"),
    testRunner = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testRunner.js"),
    setClasses = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/setClasses.js");

// Run each test
testRunner();

// Remove the "no-js" class if it exists
setClasses(classes);

delete ModernizrProto.addTest;
delete ModernizrProto.addAsyncTest;

// Run the things that are supposed to run after the tests
for (var i = 0; i < Modernizr._q.length; i++) {
    Modernizr._q[i]();
}

module.exports = Modernizr;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
// Fake some of Object.create so we can force non test results to be non "own" properties.
var Modernizr = function Modernizr() {};
Modernizr.prototype = ModernizrProto;

// Leak modernizr globally when you `require` it rather than force it here.
// Overwrite name so constructor name is nicer :D
Modernizr = new Modernizr();

module.exports = Modernizr;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tests = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/tests.js");
/**
 *
 * ModernizrProto is the constructor for Modernizr
 *
 * @class
 * @access public
 */

var ModernizrProto = {
  // The current version, dummy
  _version: '3.3.1 (browsernizr 2.1.0)',

  // Any settings that don't work as separate modules
  // can go in here as configuration.
  _config: {
    'classPrefix': '',
    'enableClasses': true,
    'enableJSClass': true,
    'usePrefixes': true
  },

  // Queue of tests
  _q: [],

  // Stub these for people who are listening
  on: function on(test, cb) {
    // I don't really think people should do this, but we can
    // safe guard it a bit.
    // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
    // This is in case people listen to synchronous tests. I would leave it out,
    // but the code to *disallow* sync tests in the real version of this
    // function is actually larger than this.
    var self = this;
    setTimeout(function () {
      cb(self[test]);
    }, 0);
  },

  addTest: function addTest(name, fn, options) {
    tests.push({ name: name, fn: fn, options: options });
  },

  addAsyncTest: function addAsyncTest(fn) {
    tests.push({ name: null, fn: fn });
  }
};

module.exports = ModernizrProto;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/classes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classes = [];
module.exports = classes;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/contains.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * contains checks to see if a string contains another string
 *
 * @access private
 * @function contains
 * @param {string} str - The string we want to check for substrings
 * @param {string} substr - The substring we want to search the first string for
 * @returns {boolean}
 */

function contains(str, substr) {
  return !!~('' + str).indexOf(substr);
}

module.exports = contains;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/createElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSVG = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/isSVG.js");
/**
 * createElement is a convenience wrapper around document.createElement. Since we
 * use createElement all over the place, this allows for (slightly) smaller code
 * as well as abstracting away issues with creating elements in contexts other than
 * HTML documents (e.g. SVG documents).
 *
 * @access private
 * @function createElement
 * @returns {HTMLElement|SVGElement} An HTML or SVG element
 */

function createElement() {
  if (typeof document.createElement !== 'function') {
    // This is the case in IE7, where the type of createElement is "object".
    // For this reason, we cannot call apply() as Object is not a Function.
    return document.createElement(arguments[0]);
  } else if (isSVG) {
    return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
  } else {
    return document.createElement.apply(document, arguments);
  }
}

module.exports = createElement;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/cssToDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * cssToDOM takes a kebab-case string and converts it to camelCase
 * e.g. box-sizing -> boxSizing
 *
 * @access private
 * @function cssToDOM
 * @param {string} name - String name of kebab-case prop we want to convert
 * @returns {string} The camelCase version of the supplied name
 */

function cssToDOM(name) {
  return name.replace(/([a-z])-([a-z])/g, function (str, m1, m2) {
    return m1 + m2.toUpperCase();
  }).replace(/^-/, '');
}
module.exports = cssToDOM;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/cssomPrefixes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
var omPrefixes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/omPrefixes.js");
var cssomPrefixes = ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : [];
ModernizrProto._cssomPrefixes = cssomPrefixes;
module.exports = cssomPrefixes;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/docElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * docElement is a convenience wrapper to grab the root element of the document
 *
 * @access private
 * @returns {HTMLElement|SVGElement} The root element of the document
 */

var docElement = document.documentElement;
module.exports = docElement;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/domPrefixes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
var omPrefixes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/omPrefixes.js");
/**
 * List of JavaScript DOM values used for tests
 *
 * @memberof Modernizr
 * @name Modernizr._domPrefixes
 * @optionName Modernizr._domPrefixes
 * @optionProp domPrefixes
 * @access public
 * @example
 *
 * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
 * than kebab-case properties, all properties are their Capitalized variant
 *
 * ```js
 * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
 * ```
 */

var domPrefixes = ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : [];
ModernizrProto._domPrefixes = domPrefixes;
module.exports = domPrefixes;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/domToCSS.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * domToCSS takes a camelCase string and converts it to kebab-case
 * e.g. boxSizing -> box-sizing
 *
 * @access private
 * @function domToCSS
 * @param {string} name - String name of camelCase prop we want to convert
 * @returns {string} The kebab-case version of the supplied name
 */

function domToCSS(name) {
  return name.replace(/([A-Z])/g, function (str, m1) {
    return '-' + m1.toLowerCase();
  }).replace(/^ms-/, '-ms-');
}
module.exports = domToCSS;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/fnBind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
 *
 * @access private
 * @function fnBind
 * @param {function} fn - a function you want to change `this` reference to
 * @param {object} that - the `this` you want to call the function with
 * @returns {function} The wrapped version of the supplied function
 */

function fnBind(fn, that) {
  return function () {
    return fn.apply(that, arguments);
  };
}

module.exports = fnBind;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/getBody.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/createElement.js");
var isSVG = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/isSVG.js");
/**
 * getBody returns the body of a document, or an element that can stand in for
 * the body if a real body does not exist
 *
 * @access private
 * @function getBody
 * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
 * artificially created element that stands in for the body
 */

function getBody() {
  // After page load injecting a fake body doesn't work so check if body exists
  var body = document.body;

  if (!body) {
    // Can't use the real body create a fake one.
    body = createElement(isSVG ? 'svg' : 'body');
    body.fake = true;
  }

  return body;
}

module.exports = getBody;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/injectElementWithStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
var docElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/docElement.js");
var createElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/createElement.js");
var getBody = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/getBody.js");
/**
 * injectElementWithStyles injects an element with style element and some CSS rules
 *
 * @access private
 * @function injectElementWithStyles
 * @param {string} rule - String representing a css rule
 * @param {function} callback - A function that is used to test the injected element
 * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
 * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
 * @returns {boolean}
 */

function injectElementWithStyles(rule, callback, nodes, testnames) {
  var mod = 'modernizr';
  var style;
  var ret;
  var node;
  var docOverflow;
  var div = createElement('div');
  var body = getBody();

  if (parseInt(nodes, 10)) {
    // In order not to give false positives we create a node for each test
    // This also allows the method to scale for unspecified uses
    while (nodes--) {
      node = createElement('div');
      node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
      div.appendChild(node);
    }
  }

  style = createElement('style');
  style.type = 'text/css';
  style.id = 's' + mod;

  // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
  // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
  (!body.fake ? div : body).appendChild(style);
  body.appendChild(div);

  if (style.styleSheet) {
    style.styleSheet.cssText = rule;
  } else {
    style.appendChild(document.createTextNode(rule));
  }
  div.id = mod;

  if (body.fake) {
    //avoid crashing IE8, if background image is used
    body.style.background = '';
    //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
    body.style.overflow = 'hidden';
    docOverflow = docElement.style.overflow;
    docElement.style.overflow = 'hidden';
    docElement.appendChild(body);
  }

  ret = callback(div, rule);
  // If this is done after page load we don't want to remove the body so check if body exists
  if (body.fake) {
    body.parentNode.removeChild(body);
    docElement.style.overflow = docOverflow;
    // Trigger layout so kinetic scrolling isn't disabled in iOS6+
    docElement.offsetHeight;
  } else {
    div.parentNode.removeChild(div);
  }

  return !!ret;
}

module.exports = injectElementWithStyles;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/inputElem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/createElement.js");
/**
 * since we have a fairly large number of input tests that don't mutate the input
 * we create a single element that can be shared with all of those tests for a
 * minor perf boost
 *
 * @access private
 * @returns {HTMLInputElement}
 */
var inputElem = createElement('input');
module.exports = inputElem;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/is.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * is returns a boolean if the typeof an obj is exactly type.
 *
 * @access private
 * @function is
 * @param {*} obj - A thing we want to check the type of
 * @param {string} type - A string to compare the typeof against
 * @returns {boolean}
 */

function is(obj, type) {
  return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === type;
}
module.exports = is;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/isSVG.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var docElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/docElement.js");
/**
 * A convenience helper to check if the document we are running in is an SVG document
 *
 * @access private
 * @returns {boolean}
 */

var isSVG = docElement.nodeName.toLowerCase() === 'svg';
module.exports = isSVG;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/mStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var modElem = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/modElem.js");
var mStyle = {
  style: modElem.elem.style
};

// kill ref for gc, must happen before mod.elem is removed, so we unshift on to
// the front of the queue.
Modernizr._q.unshift(function () {
  delete mStyle.style;
});

module.exports = mStyle;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/modElem.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var createElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/createElement.js");
/**
 * Create our "modernizr" element that we do most feature tests on.
 *
 * @access private
 */

var modElem = {
  elem: createElement('modernizr')
};

// Clean up this element
Modernizr._q.push(function () {
  delete modElem.elem;
});

module.exports = modElem;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/nativeTestProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var injectElementWithStyles = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/injectElementWithStyles.js");
var domToCSS = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/domToCSS.js");
/**
 * nativeTestProps allows for us to use native feature detection functionality if available.
 * some prefixed form, or false, in the case of an unsupported rule
 *
 * @access private
 * @function nativeTestProps
 * @param {array} props - An array of property names
 * @param {string} value - A string representing the value we want to check via @supports
 * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
 */

// Accepts a list of property names and a single value
// Returns `undefined` if native detection not available
function nativeTestProps(props, value) {
  var i = props.length;
  // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
  if ('CSS' in window && 'supports' in window.CSS) {
    // Try every prefixed variant of the property
    while (i--) {
      if (window.CSS.supports(domToCSS(props[i]), value)) {
        return true;
      }
    }
    return false;
  }
  // Otherwise fall back to at-rule (for Opera 12.x)
  else if ('CSSSupportsRule' in window) {
      // Build a condition string for every prefixed variant
      var conditionText = [];
      while (i--) {
        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
      }
      conditionText = conditionText.join(' or ');
      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function (node) {
        return getComputedStyle(node, null).position == 'absolute';
      });
    }
  return undefined;
}
module.exports = nativeTestProps;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/omPrefixes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * If the browsers follow the spec, then they would expose vendor-specific style as:
 *   elem.style.WebkitBorderRadius
 * instead of something like the following, which would be technically incorrect:
 *   elem.style.webkitBorderRadius
   * Webkit ghosts their properties in lowercase but Opera & Moz do not.
 * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
 *   erik.eae.net/archives/2008/03/10/21.48.10/
   * More here: github.com/Modernizr/Modernizr/issues/issue/21
 *
 * @access private
 * @returns {string} The string representing the vendor-specific style properties
 */

var omPrefixes = 'Moz O ms Webkit';
module.exports = omPrefixes;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/prefixes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
/**
 * List of property values to set for css tests. See ticket #21
 * http://git.io/vUGl4
 *
 * @memberof Modernizr
 * @name Modernizr._prefixes
 * @optionName Modernizr._prefixes
 * @optionProp prefixes
 * @access public
 * @example
 *
 * Modernizr._prefixes is the internal list of prefixes that we test against
 * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
 * an array of kebab-case vendor prefixes you can use within your code.
 *
 * Some common use cases include
 *
 * Generating all possible prefixed version of a CSS property
 * ```js
 * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
 *
 * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
 * ```
 *
 * Generating all possible prefixed version of a CSS value
 * ```js
 * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
 *
 * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
 * ```
 */

// we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
// values in feature detects to continue to work
var prefixes = ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['', ''];

// expose these for the plugin API. Look in the source for how to join() them against your input
ModernizrProto._prefixes = prefixes;

module.exports = prefixes;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/setClasses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var docElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/docElement.js");
var isSVG = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/isSVG.js");
/**
 * setClasses takes an array of class names and adds them to the root element
 *
 * @access private
 * @function setClasses
 * @param {string[]} classes - Array of class names
 */

// Pass in an and array of class names, e.g.:
//  ['no-webp', 'borderradius', ...]
function setClasses(classes) {
  var className = docElement.className;
  var classPrefix = Modernizr._config.classPrefix || '';

  if (isSVG) {
    className = className.baseVal;
  }

  // Change `no-js` to `js` (independently of the `enableClasses` option)
  // Handle classPrefix on this too
  if (Modernizr._config.enableJSClass) {
    var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
    className = className.replace(reJS, '$1' + classPrefix + 'js$2');
  }

  if (Modernizr._config.enableClasses) {
    // Add the new classes
    className += ' ' + classPrefix + classes.join(' ' + classPrefix);
    isSVG ? docElement.className.baseVal = className : docElement.className = className;
  }
}

module.exports = setClasses;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testAllProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
var testPropsAll = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testPropsAll.js");
/**
 * testAllProps determines whether a given CSS property is supported in the browser
 *
 * @memberof Modernizr
 * @name Modernizr.testAllProps
 * @optionName Modernizr.testAllProps()
 * @optionProp testAllProps
 * @access public
 * @function testAllProps
 * @param {string} prop - String naming the property to test (either camelCase or kebab-case)
 * @param {string} [value] - String of the value to test
 * @param {boolean} [skipValueTest=false] - Whether to skip testing that the value is supported when using non-native detection
 * @example
 *
 * testAllProps determines whether a given CSS property, in some prefixed form,
 * is supported by the browser.
 *
 * ```js
 * testAllProps('boxSizing')  // true
 * ```
 *
 * It can optionally be given a CSS value in string form to test if a property
 * value is valid
 *
 * ```js
 * testAllProps('display', 'block') // true
 * testAllProps('display', 'penguin') // false
 * ```
 *
 * A boolean can be passed as a third parameter to skip the value check when
 * native detection (@supports) isn't available.
 *
 * ```js
 * testAllProps('shapeOutside', 'content-box', true);
 * ```
 */

function testAllProps(prop, value, skipValueTest) {
  return testPropsAll(prop, undefined, undefined, value, skipValueTest);
}
ModernizrProto.testAllProps = testAllProps;
module.exports = testAllProps;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testDOMProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var is = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/is.js");
var fnBind = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/fnBind.js");
/**
 * testDOMProps is a generic DOM property test; if a browser supports
 *   a certain property, it won't return undefined for it.
 *
 * @access private
 * @function testDOMProps
 * @param {array.<string>} props - An array of properties to test for
 * @param {object} obj - An object or Element you want to use to test the parameters again
 * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
 */
function testDOMProps(props, obj, elem) {
  var item;

  for (var i in props) {
    if (props[i] in obj) {

      // return the property name as a string
      if (elem === false) {
        return props[i];
      }

      item = obj[props[i]];

      // let's bind a function
      if (is(item, 'function')) {
        // bind to obj unless overriden
        return fnBind(item, elem || obj);
      }

      // return the unbound function or obj or value
      return item;
    }
  }
  return false;
}

module.exports = testDOMProps;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var contains = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/contains.js");
var mStyle = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/mStyle.js");
var createElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/createElement.js");
var nativeTestProps = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/nativeTestProps.js");
var is = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/is.js");
var cssToDOM = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/cssToDOM.js");
// testProps is a generic CSS / DOM property test.

// In testing support for a given CSS property, it's legit to test:
//    `elem.style[styleName] !== undefined`
// If the property is supported it will return an empty string,
// if unsupported it will return undefined.

// We'll take advantage of this quick test and skip setting a style
// on our modernizr element, but instead just testing undefined vs
// empty string.

// Property names can be provided in either camelCase or kebab-case.

function testProps(props, prefixed, value, skipValueTest) {
  skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

  // Try native detect first
  if (!is(value, 'undefined')) {
    var result = nativeTestProps(props, value);
    if (!is(result, 'undefined')) {
      return result;
    }
  }

  // Otherwise do it properly
  var afterInit, i, propsLength, prop, before;

  // If we don't have a style element, that means we're running async or after
  // the core tests, so we'll need to create our own elements to use

  // inside of an SVG element, in certain browsers, the `style` element is only
  // defined for valid tags. Therefore, if `modernizr` does not have one, we
  // fall back to a less used element and hope for the best.
  var elems = ['modernizr', 'tspan'];
  while (!mStyle.style) {
    afterInit = true;
    mStyle.modElem = createElement(elems.shift());
    mStyle.style = mStyle.modElem.style;
  }

  // Delete the objects if we created them.
  function cleanElems() {
    if (afterInit) {
      delete mStyle.style;
      delete mStyle.modElem;
    }
  }

  propsLength = props.length;
  for (i = 0; i < propsLength; i++) {
    prop = props[i];
    before = mStyle.style[prop];

    if (contains(prop, '-')) {
      prop = cssToDOM(prop);
    }

    if (mStyle.style[prop] !== undefined) {

      // If value to test has been passed in, do a set-and-check test.
      // 0 (integer) is a valid property value, so check that `value` isn't
      // undefined, rather than just checking it's truthy.
      if (!skipValueTest && !is(value, 'undefined')) {

        // Needs a try catch block because of old IE. This is slow, but will
        // be avoided in most cases because `skipValueTest` will be used.
        try {
          mStyle.style[prop] = value;
        } catch (e) {}

        // If the property value has changed, we assume the value used is
        // supported. If `value` is empty string, it'll fail here (because
        // it hasn't changed), which matches how browsers have implemented
        // CSS.supports()
        if (mStyle.style[prop] != before) {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
      }
      // Otherwise just return true, or the property name if this is a
      // `prefixed()` call
      else {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
    }
  }
  cleanElems();
  return false;
}

module.exports = testProps;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testPropsAll.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
var cssomPrefixes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/cssomPrefixes.js");
var is = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/is.js");
var testProps = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testProps.js");
var domPrefixes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/domPrefixes.js");
var testDOMProps = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testDOMProps.js");
/**
 * testPropsAll tests a list of DOM properties we want to check against.
 * We specify literally ALL possible (known and/or likely) properties on
 * the element including the non-vendor prefixed one, for forward-
 * compatibility.
 *
 * @access private
 * @function testPropsAll
 * @param {string} prop - A string of the property to test for
 * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
 * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
 * @param {string} [value] - A string of a css value
 * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
 */
function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

  var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
      props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

  // did they call .prefixed('boxSizing') or are we just testing a prop?
  if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
    return testProps(props, prefixed, value, skipValueTest);

    // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
  } else {
    props = (prop + ' ' + domPrefixes.join(ucProp + ' ') + ucProp).split(' ');
    return testDOMProps(props, prefixed, elem);
  }
}

// Modernizr.testAllProps() investigates whether a given style property,
// or any of its vendor-prefixed variants, is recognized
//
// Note that the property names must be provided in the camelCase variant.
// Modernizr.testAllProps('boxSizing')
ModernizrProto.testAllProps = testPropsAll;

module.exports = testPropsAll;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testRunner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tests = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/tests.js");
var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var classes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/classes.js");
var is = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/is.js");
/**
 * Run through all tests and detect their support in the current UA.
 *
 * @access private
 */

function testRunner() {
  var featureNames;
  var feature;
  var aliasIdx;
  var result;
  var nameIdx;
  var featureName;
  var featureNameSplit;

  for (var featureIdx in tests) {
    if (tests.hasOwnProperty(featureIdx)) {
      featureNames = [];
      feature = tests[featureIdx];
      // run the test, throw the return value into the Modernizr,
      // then based on that boolean, define an appropriate className
      // and push it into an array of classes we'll join later.
      //
      // If there is no name, it's an 'async' test that is run,
      // but not directly added to the object. That should
      // be done with a post-run addTest call.
      if (feature.name) {
        featureNames.push(feature.name.toLowerCase());

        if (feature.options && feature.options.aliases && feature.options.aliases.length) {
          // Add all the aliases into the names list
          for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
            featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
          }
        }
      }

      // Run the test, or use the raw value if it's not a function
      result = is(feature.fn, 'function') ? feature.fn() : feature.fn;

      // Set each of the names on the Modernizr object
      for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
        featureName = featureNames[nameIdx];
        // Support dot properties as sub tests. We don't do checking to make sure
        // that the implied parent tests have been added. You must call them in
        // order (either in the test, or make the parent test a dependency).
        //
        // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
        // hashtag famous last words
        featureNameSplit = featureName.split('.');

        if (featureNameSplit.length === 1) {
          Modernizr[featureNameSplit[0]] = result;
        } else {
          // cast to a Boolean, if not one already
          /* jshint -W053 */
          if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
            Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
          }

          Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
        }

        classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
      }
    }
  }
}
module.exports = testRunner;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testStyles.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ModernizrProto = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/ModernizrProto.js");
var injectElementWithStyles = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/injectElementWithStyles.js");
/**
 * testStyles injects an element with style element and some CSS rules
 *
 * @memberof Modernizr
 * @name Modernizr.testStyles
 * @optionName Modernizr.testStyles()
 * @optionProp testStyles
 * @access public
 * @function testStyles
 * @param {string} rule - String representing a css rule
 * @param {function} callback - A function that is used to test the injected element
 * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
 * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
 * @returns {boolean}
 * @example
 *
 * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
 * along with (possibly multiple) DOM elements. This lets you check for features
 * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
 *
 * ```js
 * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
 *   // elem is the first DOM node in the page (by default #modernizr)
 *   // rule is the first argument you supplied - the CSS rule in string form
 *
 *   addTest('widthworks', elem.style.width === '9px')
 * });
 * ```
 *
 * If your test requires multiple nodes, you can include a third argument
 * indicating how many additional div elements to include on the page. The
 * additional nodes are injected as children of the `elem` that is returned as
 * the first argument to the callback.
 *
 * ```js
 * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
 *   document.getElementById('modernizr').style.width === '1px'; // true
 *   document.getElementById('modernizr2').style.width === '2px'; // true
 *   elem.firstChild === document.getElementById('modernizr2'); // true
 * }, 1);
 * ```
 *
 * By default, all of the additional elements have an ID of `modernizr[n]`, where
 * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
 * the second additional is `#modernizr3`, etc.).
 * If you want to have more meaningful IDs for your function, you can provide
 * them as the fourth argument, as an array of strings
 *
 * ```js
 * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
 *   elem.firstChild === document.getElementById('foo'); // true
 *   elem.lastChild === document.getElementById('bar'); // true
 * }, 2, ['foo', 'bar']);
 * ```
 *
 */

var testStyles = ModernizrProto.testStyles = injectElementWithStyles;
module.exports = testStyles;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/tests.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tests = [];
module.exports = tests;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/css/transitions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
{
  "name": "CSS Transitions",
  "property": "csstransitions",
  "caniuse": "css-transitions",
  "tags": ["css"]
}
!*/
var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var testAllProps = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testAllProps.js");
Modernizr.addTest('csstransitions', testAllProps('transition', 'all', true));

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/es6/promises.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
{
  "name": "ES6 Promises",
  "property": "promises",
  "caniuse": "promises",
  "polyfills": ["es6promises"],
  "authors": ["Krister Kari", "Jake Archibald"],
  "tags": ["es6"],
  "notes": [{
    "name": "The ES6 promises spec",
    "href": "https://github.com/domenic/promises-unwrapping"
  },{
    "name": "Chromium dashboard - ES6 Promises",
    "href": "https://www.chromestatus.com/features/5681726336532480"
  },{
    "name": "JavaScript Promises: There and back again - HTML5 Rocks",
    "href": "http://www.html5rocks.com/en/tutorials/es6/promises/"
  }]
}
!*/
/* DOC
Check if browser implements ECMAScript 6 Promises per specification.
*/
var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
Modernizr.addTest('promises', function () {
  return 'Promise' in window &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in window.Promise && 'reject' in window.Promise && 'all' in window.Promise && 'race' in window.Promise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  function () {
    var resolve;
    new window.Promise(function (r) {
      resolve = r;
    });
    return typeof resolve === 'function';
  }();
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/geolocation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
{
  "name": "Geolocation API",
  "property": "geolocation",
  "caniuse": "geolocation",
  "tags": ["media"],
  "notes": [{
    "name": "MDN documentation",
    "href": "https://developer.mozilla.org/en-US/docs/WebAPI/Using_geolocation"
  }],
  "polyfills": [
    "joshuabell-polyfill",
    "webshims",
    "geo-location-javascript",
    "geolocation-api-polyfill"
  ]
}
!*/
/* DOC
Detects support for the Geolocation API for users to provide their location to web applications.
*/
var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
// geolocation is often considered a trivial feature detect...
// Turns out, it's quite tricky to get right:
//
// Using !!navigator.geolocation does two things we don't want. It:
//   1. Leaks memory in IE9: github.com/Modernizr/Modernizr/issues/513
//   2. Disables page caching in WebKit: webk.it/43956
//
// Meanwhile, in Firefox < 8, an about:config setting could expose
// a false positive that would throw an exception: bugzil.la/688158

Modernizr.addTest('geolocation', 'geolocation' in navigator);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/inputtypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
{
  "name": "Form input types",
  "property": "inputtypes",
  "caniuse": "forms",
  "tags": ["forms"],
  "authors": ["Mike Taylor"],
  "polyfills": [
    "jquerytools",
    "webshims",
    "h5f",
    "webforms2",
    "nwxforms",
    "fdslider",
    "html5slider",
    "galleryhtml5forms",
    "jscolor",
    "html5formshim",
    "selectedoptionsjs",
    "formvalidationjs"
  ]
}
!*/
/* DOC
Detects support for HTML5 form input types and exposes Boolean subproperties with the results:

```javascript
Modernizr.inputtypes.color
Modernizr.inputtypes.date
Modernizr.inputtypes.datetime
Modernizr.inputtypes['datetime-local']
Modernizr.inputtypes.email
Modernizr.inputtypes.month
Modernizr.inputtypes.number
Modernizr.inputtypes.range
Modernizr.inputtypes.search
Modernizr.inputtypes.tel
Modernizr.inputtypes.time
Modernizr.inputtypes.url
Modernizr.inputtypes.week
```
*/
var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var inputElem = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/inputElem.js");
var docElement = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/docElement.js");
// Run through HTML5's new input types to see if the UA understands any.
//   This is put behind the tests runloop because it doesn't return a
//   true/false like all the other tests; instead, it returns an object
//   containing each input type with its corresponding true/false value

// Big thanks to @miketaylr for the html5 forms expertise. miketaylr.com/
var inputtypes = 'search tel url email datetime date month week time datetime-local number range color'.split(' ');
var inputs = {};

Modernizr.inputtypes = function (props) {
  var len = props.length;
  var smile = '1)';
  var inputElemType;
  var defaultView;
  var bool;

  for (var i = 0; i < len; i++) {

    inputElem.setAttribute('type', inputElemType = props[i]);
    bool = inputElem.type !== 'text' && 'style' in inputElem;

    // We first check to see if the type we give it sticks..
    // If the type does, we feed it a textual value, which shouldn't be valid.
    // If the value doesn't stick, we know there's input sanitization which infers a custom UI
    if (bool) {

      inputElem.value = smile;
      inputElem.style.cssText = 'position:absolute;visibility:hidden;';

      if (/^range$/.test(inputElemType) && inputElem.style.WebkitAppearance !== undefined) {

        docElement.appendChild(inputElem);
        defaultView = document.defaultView;

        // Safari 2-4 allows the smiley as a value, despite making a slider
        bool = defaultView.getComputedStyle && defaultView.getComputedStyle(inputElem, null).WebkitAppearance !== 'textfield' &&
        // Mobile android web browser has false positive, so must
        // check the height to see if the widget is actually there.
        inputElem.offsetHeight !== 0;

        docElement.removeChild(inputElem);
      } else if (/^(search|tel)$/.test(inputElemType)) {
        // Spec doesn't define any special parsing or detectable UI
        //   behaviors so we pass these through as true

        // Interestingly, opera fails the earlier test, so it doesn't
        //  even make it here.

      } else if (/^(url|email)$/.test(inputElemType)) {
        // Real url and email support comes with prebaked validation.
        bool = inputElem.checkValidity && inputElem.checkValidity() === false;
      } else {
        // If the upgraded input compontent rejects the :) text, we got a winner
        bool = inputElem.value != smile;
      }
    }

    inputs[props[i]] = !!bool;
  }
  return inputs;
}(inputtypes);

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/test/touchevents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
{
  "name": "Touch Events",
  "property": "touchevents",
  "caniuse" : "touch",
  "tags": ["media", "attribute"],
  "notes": [{
    "name": "Touch Events spec",
    "href": "https://www.w3.org/TR/2013/WD-touch-events-20130124/"
  }],
  "warnings": [
    "Indicates if the browser supports the Touch Events spec, and does not necessarily reflect a touchscreen device"
  ],
  "knownBugs": [
    "False-positive on some configurations of Nokia N900",
    "False-positive on some BlackBerry 6.0 builds – https://github.com/Modernizr/Modernizr/issues/372#issuecomment-3112695"
  ]
}
!*/
/* DOC
Indicates if the browser supports the W3C Touch Events API.

This *does not* necessarily reflect a touchscreen device:

* Older touchscreen devices only emulate mouse events
* Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
* Some browsers & OS setups may enable touch APIs when no touchscreen is connected
* Future browsers may implement other event models for touch interactions

See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).

It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](http://www.html5rocks.com/en/mobile/touchandmouse/).

This test will also return `true` for Firefox 4 Multitouch support.
*/
var Modernizr = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/Modernizr.js");
var prefixes = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/prefixes.js");
var testStyles = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/browsernizr/lib/testStyles.js");
// Chrome (desktop) used to lie about its support on this, but that has since been rectified: http://crbug.com/36415
Modernizr.addTest('touchevents', function () {
  var bool;
  if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch) {
    bool = true;
  } else {
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
    testStyles(query, function (node) {
      bool = node.offsetTop === 9;
    });
  }
  return bool;
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/enumify/enumify.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyProperties = copyProperties;

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var INITIALIZED = Symbol();

/**
 * This is an abstract class that is not intended to be
 * used directly. Extend it to turn your class into an enum
 * (initialization is performed via `MyClass.initEnum()`).
 */

var Enum = exports.Enum = function () {
    /**
     * `initEnum()` closes the class. Then calling this constructor
     * throws an exception.
     * 
     * If your subclass has a constructor then you can control
     * what properties are added to `this` via the argument you
     * pass to `super()`. No arguments are fine, too.
     */

    function Enum() {
        var instanceProperties = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

        _classCallCheck(this, Enum);

        // new.target would be better than this.constructor,
        // but isn’t supported by Babel
        if ({}.hasOwnProperty.call(this.constructor, INITIALIZED)) {
            throw new Error('Enum classes can’t be instantiated');
        }
        if ((typeof instanceProperties === 'undefined' ? 'undefined' : _typeof(instanceProperties)) === 'object' && instanceProperties !== null) {
            copyProperties(this, instanceProperties);
        }
    }
    /**
     * Set up the enum, close the class.
     * 
     * @param arg Either an object whose properties provide the names
     * and values (which must be mutable objects) of the enum constants.
     * Or an Array whose elements are used as the names of the enum constants
     * The values are create by instantiating the current class.
     */

    _createClass(Enum, [{
        key: 'toString',

        /**
         * Default `toString()` method for enum constant.
         */
        value: function toString() {
            return this.constructor.name + '.' + this.name;
        }
    }], [{
        key: 'initEnum',
        value: function initEnum(arg) {
            Object.defineProperty(this, 'enumValues', {
                value: [],
                configurable: false,
                writable: false,
                enumerable: true
            });
            if (Array.isArray(arg)) {
                this._enumValuesFromArray(arg);
            } else {
                this._enumValuesFromObject(arg);
            }
            Object.freeze(this.enumValues);
            this[INITIALIZED] = true;
            return this;
        }
    }, {
        key: '_enumValuesFromArray',
        value: function _enumValuesFromArray(arr) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    this._pushEnumValue(new this(), key);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: '_enumValuesFromObject',
        value: function _enumValuesFromObject(obj) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(obj)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    var value = new this(obj[key]);
                    this._pushEnumValue(value, key);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: '_pushEnumValue',
        value: function _pushEnumValue(enumValue, name) {
            enumValue.name = name;
            enumValue.ordinal = this.enumValues.length;
            Object.defineProperty(this, name, {
                value: enumValue,
                configurable: false,
                writable: false,
                enumerable: true
            });
            this.enumValues.push(enumValue);
        }

        /**
         * Given the name of an enum constant, return its value.
         */

    }, {
        key: 'enumValueOf',
        value: function enumValueOf(name) {
            return this.enumValues.find(function (x) {
                return x.name === name;
            });
        }

        /**
         * Make enum classes iterable
         */

    }, {
        key: Symbol.iterator,
        value: function value() {
            return this.enumValues[Symbol.iterator]();
        }
    }]);

    return Enum;
}();

function copyProperties(target, source) {
    // Ideally, we’d use Reflect.ownKeys() here,
    // but I don’t want to depend on a polyfill
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = Object.getOwnPropertyNames(source)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            var desc = Object.getOwnPropertyDescriptor(source, key);
            Object.defineProperty(target, key, desc);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return target;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/vendor/pyrsmk-toast/toast.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;(function (root, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
		module.exports = factory();
	} else {
		root.toast = factory();
	}
})(undefined, function () {
	/*! toast 2.1.0 (https://github.com/pyrsmk/toast) */

	var handled_resources = {};

	function toast() {
		var head = document.getElementsByTagName('head')[0],


		// Load as much resources as we can
		loadResources = function loadResources(resources) {
			// Waiting for DOM readiness then load resources
			if (!head) {
				setTimeout(function () {
					loadResources(resources);
				}, 50);
			}
			// Load resources
			else if (resources.length) {
					var i = -1,
					    resource,
					    callback;
					while (resource = resources[++i]) {
						// Resource
						if (typeof resource == 'string') {
							loadResource(resource);
						}
						// Callback
						else if (typeof resource == 'function') {
								callback = resource;
								break;
							}
					}
					watchResources(callback, Array.prototype.slice.call(resources, i + 1));
				}
		},


		// Load one resource
		loadResource = function loadResource(resource) {
			// Extract resource type
			var implicit_type = /\.(\w+)$/.exec(resource),
			    explicit_type = /^\[(\w+)\](.+)/.exec(resource),
			    type,
			    node;
			if (explicit_type !== null) {
				type = explicit_type[1];
				resource = explicit_type[2];
			} else if (implicit_type !== null) {
				type = implicit_type[1];
			} else {
				return;
			}
			// Verify if the resource is not already handled
			if (resource in handled_resources) {
				return;
			}
			// Mark the resource as handled (but not loaded yet)
			handled_resources[resource] = false;
			// Load resource
			switch (type) {
				case 'js':
					// Create SCRIPT element
					node = document.createElement('script');
					node.src = resource;
					node.type = 'text/javascript';
					head.appendChild(node);
					// Watch loading state
					var version = navigator.appVersion.match(/MSIE (\d)/);
					if (version !== null && parseInt(version[1], 10) < 9) {
						// IE<9
						node.onreadystatechange = function () {
							if (/ded|co/.test(this.readyState)) {
								handled_resources[resource] = true;
							}
						};
					} else {
						// Other browsers
						node.onload = function () {
							handled_resources[resource] = true;
						};
					}
					break;
				case 'css':
					// Create LINK element
					node = document.createElement('link');
					node.rel = 'styleSheet';
					node.href = resource;
					head.appendChild(node);
					// Watch loading state
					watchStylesheet(node, resource);
					break;
				default:
					delete handled_resources[resource];
					return;
			}
		},


		// Watch if all resources have been loaded
		watchResources = function watchResources(callback, resourcesToLoad) {
			for (var resource in handled_resources) {
				if (!handled_resources[resource]) {
					setTimeout(function () {
						watchResources(callback, resourcesToLoad);
					}, 50);
					return;
				}
			}
			if (typeof callback == 'function') {
				callback();
			}
			loadResources(resourcesToLoad);
		},


		// Watch if a CSS resource has been loaded
		watchStylesheet = function watchStylesheet(node, resource) {
			if (node.sheet || node.styleSheet) {
				handled_resources[resource] = true;
			} else {
				setTimeout(function () {
					watchStylesheet(node, resource);
				}, 50);
			}
		};

		// Load resources
		loadResources(arguments);
	}
	return toast;
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/modules/datepicker/dynamic-load.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = load;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _services = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/services/index.js");

var services = _interopRequireWildcard(_services);

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
// Constants


//
// Dependencies
var MODULE_NAME = registry.DATEPICKER_MODULE; /**
                                               * Datepicker - Dynamic Load
                                               * Responsible for determining if the datepicker needs to load, and for actually loading the files.
                                               */

//
// Utilities

var log = (0, _debug2.default)(MODULE_NAME);

var MODULE_SELECTOR = 'input[type="date"]';
var ASSETS = ['../styles/nt-datepicker.module.css', '../scripts/nt-datepicker.module.js'];

//
// Load
function load() {

	if (!services.polyfillFlags.useDateFieldPolyFill) {
		log('Polyfill not required.');
		return;
	}

	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/modules/locator/dynamic-load.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSETS = exports.MODULE_SELECTOR = exports.MODULE_NAME = undefined;
exports.default = load;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// Constants
var MODULE_NAME = exports.MODULE_NAME = registry.LOCATOR_MODULE; /**
                                                                  * @name Locator - Dynamic Load
                                                                  * Responsible for determining if the PS Quote Form needs to load, and for actually loading the files.
                                                                  * @author Rhys Lloyd
                                                                  */

//
// Utilities
//
// Dependencies
var MODULE_SELECTOR = exports.MODULE_SELECTOR = '[data-locator]';
var ASSETS = exports.ASSETS = ['../scripts/nt-locator.module.js', '../styles/nt-locator.module.css'];

//
// Load
function load() {
  registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/modules/product-selector/dynamic-load.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSETS = exports.MODULE_SELECTOR = exports.MODULE_NAME = undefined;
exports.default = load;

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)("hf-ps.dynamic-load");

//
// Dependencies
/**
 * Health Fund Product Selector - Dynamic Load
 * Responsible for determining if the PS Quote Form needs to load, and for actually loading the files.
 * @author Rhys Lloyd
 */

//
// Utilities


//
// Constants
var MODULE_NAME = exports.MODULE_NAME = _names.HF_PRODUCT_SELECTOR_MODULE;
var MODULE_SELECTOR = exports.MODULE_SELECTOR = "[data-hf-ps]";
var ASSETS = exports.ASSETS = ["../styles/nt-datepicker.module.css", "../styles/nthf-product-selector.module.css", "../scripts/core-product-selector.module.js"];

//
// Load
function load() {
  registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/nt-main.app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;
exports.loadDynamicModules = loadDynamicModules;
exports.exec = exec;

var _registry = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/index.js");

var registry = _interopRequireWildcard(_registry);

var _names = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/registry/names.js");

var _dynamicLoad = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/modules/datepicker/dynamic-load.js");

var _dynamicLoad2 = _interopRequireDefault(_dynamicLoad);

var _dynamicLoad3 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/modules/cover-selector/dynamic-load.js");

var _dynamicLoad4 = _interopRequireDefault(_dynamicLoad3);

var _dynamicLoad5 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/modules/locator/dynamic-load.js");

var _dynamicLoad6 = _interopRequireDefault(_dynamicLoad5);

var _dynamicLoad7 = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/modules/product-selector/dynamic-load.js");

var _dynamicLoad8 = _interopRequireDefault(_dynamicLoad7);

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

//
// Local Dependencies
// log('Load dependencies...');
/* Favicons entry point for webpack
 * html_code.html as expected output from realfavicongenerator.net
 * manually insert `WEBPACKHACK` to content attribute of meta[name="msapplication-config"] i.e.
 * <meta name="msapplication-config" WEBPACKHACKcontent="./browserconfig.xml">
 */
/**
 * Queensland Country Health Fund
 * Main website script runner.
 * @author Rhys Lloyd
 */

//
// Dependencies
__webpack_require__("/tool/node_modules/file-loader/dist/cjs.js??ref--13-0!/tool/node_modules/extract-loader/lib/extractLoader.js!/tool/node_modules/html-loader/index.js??ref--13-2!/tool/project/client/src/site__nt/favicons/html_code.html");
//
// Dynamic Module Loaders


// TODO: redundant dynamic load?


//
// Constants

var MODULE_NAME = _names.HF_APP_MODULE;
var log = (0, _debug2.default)(MODULE_NAME);
//
// Register
if (!registry.exists(MODULE_NAME)) {
	registry.register(MODULE_NAME, registry.STATE.LOADING);
}

/**
 * Loads dynamic modules (polyfills etc.)
 */
function loadDynamicModules() {
	//
	// Dynamic Modules
	log('Load dynamic modules...');

	(0, _dynamicLoad4.default)();
	(0, _dynamicLoad6.default)();
	(0, _dynamicLoad2.default)();
	(0, _dynamicLoad8.default)();

	log('...dynamic modules done.');
}

//
// Application
/**
 * Execute Core Application
 */
function exec() {
	log('Running...');

	// $(document).ready(() => {
	// 	log('Running document ready tasks...');
	// 	time('[hf-main.app] ...document ready tasks done.');
	//
	// 	timeEnd('[hf-main.app] ...document ready tasks done.');
	// });
}

exports.default = exec;

registry.setState(MODULE_NAME, registry.STATE.LOADED);

//
// Conditionally Self Execute
if (!registry.isRegistered(MODULE_NAME)) {
	exec();
	loadDynamicModules();
	registry.setState(MODULE_NAME, registry.STATE.REGISTERED);
}

/***/ }),

/***/ "/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--25-0!/tool/node_modules/css-loader/index.js??ref--25-1!/tool/node_modules/postcss-loader/lib/index.js??ref--25-2!/tool/node_modules/sass-loader/lib/loader.js??ref--25-3!/tool/project/client/src/site__nt/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/tool/node_modules/file-loader/dist/cjs.js??ref--13-0!/tool/node_modules/extract-loader/lib/extractLoader.js!/tool/node_modules/html-loader/index.js??ref--13-2!/tool/project/client/src/site__nt/favicons/html_code.html":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicons__nt/favicons.webpackcruft";

/***/ }),

/***/ "multi /tool/project/client/src/site__nt/nt-main.app.js /tool/project/client/src/site__nt/index.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--22-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/site__nt/nt-main.app.js");
module.exports = __webpack_require__("/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--25-0!/tool/node_modules/css-loader/index.js??ref--25-1!/tool/node_modules/postcss-loader/lib/index.js??ref--25-2!/tool/node_modules/sass-loader/lib/loader.js??ref--25-3!/tool/project/client/src/site__nt/index.scss");


/***/ })

},["multi /tool/project/client/src/site__nt/nt-main.app.js /tool/project/client/src/site__nt/index.scss"]);


// WEBPACK FOOTER //
// scripts/nt-main.app--ecdf3d1f56b1b0d807ec.js